import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { ReportsState, LoadLinescore, getLinescoreLoaded, getLinescoreLoading } from '../store';
import { map, tap, take, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LinescoreDataGuard  {

    constructor(private store: Store<ReportsState>) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const cacheKey: string = next.parent.params.cacheKey;
        return this.store.pipe(
            select(getLinescoreLoaded),
            take(1),
            switchMap(loaded => loaded ? of(true) : this.checkstore(cacheKey))
        );

    }

    checkstore(cacheKey: string): Observable<boolean> {
        let reloaded: boolean = false;
        return this.store.select(getLinescoreLoading).pipe(
            tap(loading => {
                if (!loading && !reloaded) {
                    this.store.dispatch(new LoadLinescore(cacheKey))
                    reloaded = true;
                }
            }),
            take(1),
            map(() => true)
        );
    }

}
